var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _g3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 342,
    viewBox: "0 0 350 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9471 272.242C24.9471 272.242 30.2358 261.586 40.8205 259.591C51.4052 257.595 55.4466 269.912 58.2478 272.912C61.049 275.913 62.0112 270.246 67.0007 270.582C71.9901 270.917 73.2232 274.245 74.1284 275.906C75.0336 277.567 78.5262 272.085 80.5433 272.834C82.5605 273.582 83.4515 275.942 83.4515 275.942L90.6362 277.239H9.40861C9.40861 277.239 8.78849 271.579 14.0773 270.247C19.366 268.914 22.8087 272.912 24.9471 272.242Z",
    stroke: "black",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.377 52.2516C266.377 52.2516 271.666 41.5957 282.258 39.5928C292.85 37.5899 296.87 49.9209 299.671 52.9288C302.472 55.9367 303.406 50.263 308.381 50.598C313.356 50.933 314.611 54.2616 315.544 55.9295C316.478 57.5974 319.935 52.1019 321.959 52.8504C323.984 53.5988 324.867 55.958 324.867 55.958L332.059 57.2553H250.817C250.817 57.2553 250.19 51.5959 255.486 50.263C260.782 48.9301 264.196 52.9288 266.377 52.2516Z",
    stroke: "black",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.324 69.1447C245.785 68.2181 247.026 66.3792 248.43 65.2031C251.903 62.1748 256.359 60.5129 260.967 60.5273C271.452 60.7554 275.736 72.8939 277.019 73.3572C278.302 73.8205 281.089 69.0093 285.793 69.9216C290.498 70.834 291.36 74.9609 292.864 76.1085C294.368 77.2561 298.424 74.0486 300.997 74.9609C303.57 75.8733 303.135 78.8598 305.701 79.0879C308.267 79.316 309.771 77.9403 311.695 78.3751C313.62 78.8099 314.91 80.8983 314.91 80.8983C285.145 80.8983 255.382 80.8983 225.621 80.8983C203.858 80.8983 182.099 80.8983 160.345 80.8983C162.697 76.6217 165.969 72.73 170.324 71.0692C176.953 68.5389 184.123 71.782 191.066 72.9794C191.75 73.1756 192.48 73.1277 193.133 72.844C193.974 72.3736 194.287 71.283 194.508 70.2994C195.749 64.6685 196.433 58.7169 199.334 53.8415C203.853 46.2362 213.832 42.9931 221.565 46.614C228.821 50.021 233.048 57.9756 237.296 65.1461C238.047 66.6271 239.107 67.9299 240.404 68.9665C240.948 69.4216 241.626 69.6855 242.334 69.7177C243.042 69.7499 243.741 69.5486 244.324 69.1447Z",
    stroke: "black",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46 157.984C229.413 156.751 231.067 154.292 232.934 152.724C237.71 148.725 243.555 146.352 249.656 146.48C263.648 146.787 269.357 162.981 271.039 163.587C272.721 164.193 276.463 157.778 282.743 159.004C289.022 160.23 290.17 165.725 292.166 167.25C294.161 168.776 299.593 164.499 303.014 165.725C306.435 166.951 305.865 170.914 309.294 171.221C312.722 171.527 314.718 169.695 317.291 170.308C319.864 170.921 321.568 173.665 321.568 173.665C281.871 173.665 242.177 173.665 202.485 173.665H115.469C118.598 167.963 122.968 162.76 128.762 160.55C137.594 157.172 147.159 161.477 156.418 163.102C157.331 163.361 158.306 163.296 159.176 162.917C160.296 162.29 160.716 160.835 161.008 159.517C162.669 152.018 163.574 144.078 167.423 137.571C173.468 127.421 186.782 123.094 197.082 127.927C206.761 132.467 212.406 143.08 218.073 152.624C219.206 154.542 220.425 156.495 222.207 157.721C224.31 159.132 225.949 158.918 227.46 157.984Z",
    stroke: "black",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.149 140.95C158.15 147.55 168.293 152.903 168.293 152.903C167.881 150.646 167.057 148.483 165.862 146.524C164.052 143.837 146.831 132.047 146.831 132.047C149.658 133.169 152.544 134.135 155.477 134.941C158.328 135.554 178.885 139.931 178.885 139.931C177.716 139.425 176.607 138.792 175.577 138.042C173.724 136.723 167.067 134.314 157.801 130.985C148.535 127.657 136.018 121.071 136.018 121.071C136.018 121.071 140.338 120.885 143.595 120.878C146.853 120.871 181.814 129.923 181.814 129.923C179.538 128.708 177.18 127.653 174.758 126.766C170.702 125.276 169.055 125.012 164.971 123.523C159.968 121.588 154.804 120.095 149.54 119.061C143.46 117.942 123.88 111.719 123.288 111.541C132.804 120.094 139.639 126.438 139.639 126.438C139.639 126.438 146.118 134.357 152.149 140.95Z",
    fill: "#FFAE0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7048 36.6068C61.7048 36.6068 74.2923 30.6837 84.82 30.2631C95.3476 29.8426 129.497 27.6187 129.497 27.6187C129.497 27.6187 120.373 26.7135 114.471 27.1697C108.57 27.6259 104.599 26.6565 100.216 26.3144C95.8323 25.9722 85.2477 26.3856 81.0922 25.7299C76.9367 25.0741 70.144 28.695 61.4695 30.3986C52.7951 32.1021 39.673 38.1535 39.673 38.1535C39.673 38.1535 36.1091 33.3138 37.3279 32.2945C38.5468 31.2753 41.2909 29.9994 46.9219 27.9823C54.1263 25.3712 61.461 23.1349 68.8966 21.2822C78.5405 18.8445 119.824 17.0412 119.824 17.0412L93.694 15.1523C93.694 15.1523 82.3752 17.3334 76.5875 16.9414C70.7997 16.5494 57.8344 18.5095 48.4044 20.6407C39.6444 22.6222 28.7604 28.695 27.2778 29.5717C28.8245 30.7763 30.3214 31.9168 31.7327 32.9645C36.3136 36.4908 40.6677 40.3022 44.7693 44.376C47.3514 42.5698 50.101 41.016 52.9804 39.7359C59.2813 36.7494 61.7048 36.6068 61.7048 36.6068Z",
    fill: "#FFAE0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.203 114.941C157.117 115.653 183.518 115.846 183.518 115.846C183.518 115.846 166.896 112.396 164.38 112.011C161.864 111.626 156.625 111.142 147.067 110.849C137.508 110.557 131.991 108.504 125.947 106.53C121.794 105.097 117.767 103.321 113.908 101.22C113.908 101.22 121.485 101.034 125.676 101.683C129.867 102.332 134.8 102.588 150.31 104.327C165.82 106.067 182.919 104.263 182.919 104.263L177.716 102.417C175.114 101.498 173.311 102.075 169.74 101.861C166.169 101.647 157.751 101.712 151.586 100.578C145.42 99.445 142.148 99.4521 129.682 98.0194C117.216 96.5867 104.243 93.8853 104.243 93.8853C107.851 93.6224 111.47 93.5557 115.084 93.6857C120.024 93.9423 119.803 94.2488 125.063 94.7264C130.324 95.2039 134.572 93.1155 143.431 92.4384C152.291 91.7612 178.806 87.8339 178.806 87.8339C178.806 87.8339 173.867 87.5773 171.679 87.4062C169.49 87.2351 157.053 87.6985 152.605 88.7248C148.157 89.7512 128.456 90.6208 116.296 89.4376C109.46 88.8035 102.695 87.5583 96.0819 85.7169C96.0819 85.7169 103.837 86.5865 107.315 86.2658C110.794 85.945 117.843 85.8524 126.831 84.3342C135.819 82.816 171.629 77.5985 171.629 77.5985C171.629 77.5985 155.328 77.5985 151.849 77.9406C148.371 78.2827 142.377 78.1829 125.477 81.034C108.577 83.8851 89.2464 78.9884 89.2464 78.9884C89.2464 78.9884 97.5787 78.4039 101.891 78.2186C108.436 78.0426 114.961 77.397 121.414 76.287C130.922 74.6761 166.119 69.0167 166.119 69.0167C166.119 69.0167 147.302 68.6532 139.504 69.1521C131.706 69.651 131.051 70.5776 116.866 73.5143C102.682 76.4509 81.6554 72.6589 81.6554 72.6589C81.6554 72.6589 88.9684 70.8841 90.9927 70.0003C93.017 69.1165 101.684 67.3773 109.404 66.3509C117.123 65.3245 156.347 57.9188 156.347 57.9188C156.347 57.9188 142.555 58.3465 140.88 58.0827C139.205 57.819 130.038 58.2823 123.609 58.7955C117.18 59.3087 105.597 63.1933 96.0819 64.7971C89.1656 65.8519 82.1957 66.5182 75.2048 66.7928C75.2048 66.7928 76.4735 66.2012 78.7188 65.0038C84.2661 62.1191 90.0397 59.6924 95.9821 57.7477C104.478 54.9537 147.687 45.2172 147.687 45.2172C147.687 45.2172 114.03 48.724 103.495 50.506C92.96 52.2879 84.8201 57.7192 78.4479 60.1498C72.0757 62.5803 68.6259 61.5753 68.6259 61.5753L60.5858 55.8233C62.984 55.4119 65.3308 54.7428 67.5852 53.8275C69.9106 52.7975 72.1612 51.6066 74.3209 50.2636C78.284 47.9685 82.6461 46.4147 86.1672 44.7325C89.6883 43.0504 95.5901 42.5942 102.155 41.2257C108.719 39.8571 140.352 37.227 140.352 37.227C140.352 37.227 132.683 36.892 128.805 36.4572C124.928 36.0224 121.756 36.557 117.437 36.7423C113.117 36.9276 106.161 37.5406 98.3628 38.0396C90.565 38.5385 91.1852 38.9733 80.5435 42.1238C69.9018 45.2742 57.4068 49.836 53.1302 48.6528C50.7472 47.9366 48.4428 46.9814 46.252 45.8017C54.5629 53.8774 63.5296 63.0365 76.4022 72.1743C88.6406 80.8843 108.99 98.7179 123.296 111.569C123.531 111.619 129.874 112.938 136.453 113.964C143.153 115.019 143.267 114.178 150.203 114.941Z",
    fill: "#FFAE0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.306492 0.18457L0 0.312869V6.83474L3.87036 4.77483C8.90253 2.10193 11.6325 2.06629 17.299 0.18457H0.306492Z",
    fill: "#FFAE0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5264 20.855C26.4651 19.4294 27.0781 19.8856 28.575 19.0873C30.0718 18.289 39.3164 15.1029 42.7092 14.2547C47.9475 13.1004 53.2406 12.2107 58.5684 11.5889C64.1495 10.9189 109.054 9.32944 109.054 9.32944C109.054 9.32944 90.7145 6.98442 87.671 6.68506C84.6274 6.38569 77.3571 6.79197 74.3207 6.49261C71.2843 6.19324 59.4665 7.09134 57.5777 7.14123C50.9912 7.50341 44.5244 9.05369 38.4896 11.7172C29.6441 15.6517 13.3858 17.5834 13.3858 17.5834L6.79262 12.4371C10.0961 12.1955 13.3798 11.7335 16.6218 11.0544C21.0695 10.028 46.1733 4.16897 56.537 1.32501C58.9695 0.739207 61.4467 0.357734 63.9427 0.18457L48.7536 0.18457C43.0514 1.28937 36.3513 2.5581 29.7795 3.67003C16.9496 5.80835 4.55451 7.04144 0.235107 7.42634C5.93729 12.2518 16.5362 21.1543 25.6954 28.3391L21.269 24.1337C22.1937 22.8917 23.2905 21.7877 24.5264 20.855Z",
    fill: "#FFAE0A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4282 117.079C30.5947 118.206 30.959 119.294 31.5045 120.294C31.5045 120.294 31.0341 118.897 30.4282 117.079Z",
    fill: "#FFAE0A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.852 124.507L124.179 112.988C127.743 118.455 140.872 138.256 145.349 142.64C150.559 147.743 158.506 156.182 158.506 156.182C158.506 156.182 152.712 146.011 148.528 140.729C144.344 135.448 136.852 124.507 136.852 124.507Z",
    fill: "#FFAE0A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.725 133.858C135.833 147.508 137.608 151.556 140.652 155.12C142.48 157.259 144.538 159.19 146.788 160.879C146.788 160.879 139.639 144.165 135.12 133.473C131.958 126.364 128.287 119.491 124.137 112.91L114.229 103.907C115.555 106.238 124.122 121.292 129.725 133.858Z",
    fill: "#FFAE0A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6656 74.0995C67.6707 70.8065 69.0748 63.9567 69.1889 63.4079L35.2609 34.5477L0 6.52148V12.3021C0.748412 16.3221 1.3614 23.2716 0.449047 34.4764C0.299365 36.3296 0.149682 38.0403 0 39.7367V72.175C2.42343 79.6021 5.97304 88.1411 5.97304 88.1411C5.97304 88.1411 4.83973 70.1222 4.40494 53.0727C3.97014 36.0231 4.81122 11.9599 4.81122 11.9599C4.81122 11.9599 9.47988 10.6271 10.549 37.8977C11.6182 65.1684 9.12349 77.813 9.62243 82.3605C10.1214 86.908 13.3075 99.41 13.3075 99.41C13.3075 99.41 12.5519 72.3247 15.0324 56.4441C17.5128 40.5635 13.3716 17.5837 13.3716 17.5837C13.3716 17.5837 22.8087 26.5932 20.1857 53.1297C17.5627 79.6662 16.8642 93.102 17.3988 96.2738C17.9334 99.4457 20.3782 109.104 20.3782 109.104C20.3782 109.104 22.6092 77.1929 24.3982 66.8363C25.7596 58.9459 25.724 46.5579 25.168 39.7509C28.0191 52.1817 31.3264 68.9746 30.6706 78.2906C29.5587 94.2424 27.2422 104.663 27.7768 107.864C28.4961 110.981 29.3812 114.057 30.4283 117.08C29.9151 114.478 29.6442 110.152 30.8559 103.537C33.1226 91.1918 38.7748 74.7481 36.6365 62.0607C34.4982 49.3734 27.0854 29.6723 27.0854 29.6723L38.447 40.535C38.447 40.535 41.1911 47.1353 40.514 62.4741C39.8369 77.813 36.7292 86.7583 36.5296 96.8512C36.33 106.944 38.169 125.925 38.169 125.925C38.169 125.925 39.1384 104.293 40.6637 95.611C42.189 86.9294 46.095 76.2093 47.5705 65.6317C49.0459 55.0542 44.3131 44.7118 44.3131 44.7118C44.3131 44.7118 55.3539 58.6323 54.2278 68.0409C53.1016 77.4495 50.7851 87.9201 48.2975 100.572C46.718 109.223 45.9236 118 45.924 126.795C45.8883 128.163 48.718 135.291 48.2333 134.015C47.7487 132.739 50.0295 105.989 52.9163 97.3501C55.803 88.7113 56.3661 80.7282 57.6348 73.7217C58.9036 66.7151 54.9477 51.3406 54.9477 51.3406C54.9477 51.3406 65.233 62.3815 64.5772 63.3081C63.9215 64.2347 63.7433 66.4372 60.3006 90.9423C56.8579 115.447 58.0767 126.11 58.7895 130.337C59.5023 134.564 62.6955 143.816 62.6955 143.816C62.6955 143.816 60.1438 123.858 62.1823 108.562C64.2208 93.2659 65.6179 77.535 66.6656 74.0995Z",
    fill: "#FFAE0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.269 24.1338C21.269 24.1338 21.3332 24.3547 21.4401 24.761L21.269 24.1338Z",
    fill: "#FFAE0A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2031 63.344V63.3868L73.4798 67.0148C71.9045 60.2577 69.2031 63.344 69.2031 63.344Z",
    fill: "#FFAE0A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4656 67.0137C74.0215 69.4514 74.4349 73.1506 74.5205 78.753C74.827 99.901 71.1562 116.829 71.3486 124.406C71.5411 131.983 75.4043 150.066 75.4043 150.066C75.4043 150.066 72.1042 127.257 75.6894 116.316C79.2747 105.375 80.7501 88.2828 80.6788 81.2335L80.5719 74.1842C80.5719 74.1842 87.6996 85.7596 86.5735 98.4184C85.4473 111.077 80.8713 130.643 81.3132 136.545C81.7551 142.446 87.4715 155.348 87.4715 155.348C87.4715 155.348 86.3881 139.225 87.6355 125.696C88.8828 112.168 90.3226 102.952 90.3583 98.3258C90.3939 93.6999 88.8757 81.4544 88.8757 81.4544C88.8757 81.4544 92.8886 84.3055 94.3284 99.2738C95.7682 114.242 96.7091 124.691 95.7112 130.023C94.7133 135.354 94.9984 143.466 96.0462 146.552C97.094 149.638 101.214 159.603 101.214 159.603C101.214 159.603 98.4554 146.474 100.195 134.221C101.713 123.529 101.449 108.476 101.028 101.747C102.732 109.196 104.749 119.089 105.562 127.343C107.087 142.846 108.648 153.715 110.373 155.854C112.098 157.992 115.141 161.556 115.141 161.556C115.141 161.556 112.333 153.102 111.62 145.59C110.908 138.077 110.993 120.963 109.439 113.344C107.885 105.724 106.146 97.0428 106.146 97.0428C110.842 107.079 114.439 117.595 116.873 128.405C120.558 145.447 121.321 151.57 123.709 156.06C125.493 159.198 127.628 162.123 130.074 164.778C130.074 164.778 125.505 148.968 124.293 140.201C123.082 131.434 120.95 118.747 119.667 115.967C118.506 113.458 114.856 105.382 114.165 103.85L75.554 68.7956L73.4656 67.0137Z",
    fill: "#FFAE0A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4656 67.0137C74.0215 69.4514 74.4349 73.1506 74.5205 78.753C74.5205 80.649 74.5205 82.5165 74.5205 84.3412C76.4378 86.4795 78.3409 88.5537 80.2227 90.5566C80.5292 86.786 80.6575 83.5072 80.6289 81.2549L80.522 74.2055C80.522 74.2055 87.051 84.8259 86.6162 96.8717C87.7994 97.9741 89.0088 99.0576 90.2443 100.122C90.2443 99.4876 90.3084 98.896 90.3084 98.3757C90.3084 93.7498 88.8258 81.5043 88.8258 81.5043C88.8258 81.5043 92.8387 84.3554 94.2785 99.3237C94.4211 100.856 94.5637 102.324 94.6991 103.764C96.7875 105.382 98.9757 106.957 101.257 108.49C101.2 105.817 101.1 103.501 100.993 101.733C101.527 104.085 102.098 106.687 102.654 109.402C104.797 110.785 107.059 112.137 109.439 113.458V113.351C107.885 105.731 106.146 97.0499 106.146 97.0499C108.967 103.061 111.389 109.252 113.395 115.582C115.666 116.746 118.064 117.882 120.587 118.989C120.362 117.968 120.055 116.967 119.668 115.995C118.506 113.486 114.856 105.411 114.165 103.878L75.554 68.7956L73.4656 67.0137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2031 63.343V63.3858L73.4798 67.0138C71.9045 60.2567 69.2031 63.343 69.2031 63.343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.165 103.871L114.229 103.928L114.044 103.614L114.165 103.871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6689V12.3012C0.22096 13.4416 0.427664 14.8672 0.584474 16.5778L4.576 20.1987C4.64728 17.3476 4.71143 15.0596 4.76132 13.627L0 10.6689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.003 120.022C125.189 120.973 127.479 121.885 129.874 122.759C127.515 118.426 125.306 114.798 124.137 112.93L114.229 103.928C115.077 105.41 118.891 112.089 123.003 120.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8066 25.4446L15.2676 20.1416C17.3734 23.7647 18.8213 27.7318 19.5442 31.8596C22.7374 34.1618 26.6221 37.0557 30.8773 40.4129C28.8245 34.2688 27.0854 29.6714 27.0854 29.6714L38.447 40.534C38.447 40.534 39.4235 42.9004 40.0721 48.0894C42.4314 50.128 44.8263 52.2734 47.1998 54.5044C46.6071 51.1382 45.6339 47.8502 44.2988 44.7038C44.2988 44.7038 50.4002 52.3803 53.0659 60.1994C54.5556 61.7034 56.0382 63.243 57.4851 64.8039C56.8897 60.2689 56.0378 55.7712 54.9334 51.3325C54.9334 51.3325 65.233 62.3805 64.5772 63.3071C64.1709 63.8702 63.95 64.9109 63.059 71.1476L66.4304 75.0251C66.5088 74.6545 66.5872 74.3123 66.6656 74.0771C67.6706 70.7841 69.0748 63.9344 69.1889 63.3855L35.2609 34.5467L23.8066 25.4446ZM21.2691 24.1331C21.2691 24.1331 21.3333 24.3541 21.4402 24.7604L21.2691 24.1331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6281 19.1295L7.53394 15.3447C8.53854 18.3801 9.21012 21.5157 9.53683 24.6963L10.8626 25.9009C10.8626 25.9009 12.3523 26.856 14.8826 28.6023C14.4336 24.4183 13.9275 20.9899 13.6281 19.1295Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.194 112.987C125.498 114.976 128.05 118.839 130.993 123.18L131.606 123.408C133.745 124.185 135.748 124.926 137.665 125.646L136.867 124.506L124.194 112.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.136 112.93L124.193 112.987L123.274 111.562C123.274 111.562 123.595 112.089 124.136 112.93Z",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.693 129.653C136.731 122.789 136.852 118.847 75.2261 66.7863C46.8434 42.83 21.4473 22.0883 0 5.0459V9.57913C13.0936 19.9001 27.0212 31.2474 41.5974 43.6639C128.263 117.272 148.513 135.298 148.513 135.298C147.653 133.167 146.351 131.243 144.693 129.653Z",
    fill: "#FFAE0A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0173 146.616C97.0864 149.695 101.199 159.602 101.199 159.602C100.24 154.541 99.7128 149.407 99.6239 144.256C98.4455 140.904 96.9489 137.673 95.1548 134.605C94.8697 139.253 95.2261 144.321 96.0173 146.616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.865 145.134C152.783 150.123 158.556 156.189 158.556 156.189C158.556 156.189 154.522 149.118 150.78 143.701C150.117 143.092 149.349 142.609 148.513 142.275C148.257 143.195 148.071 144.164 147.865 145.134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3704 89.666C38.0048 95.0403 39.0811 100.55 39.4588 105.917C38.6178 104.157 37.6698 101.99 36.5222 99.8587C36.6576 110.294 38.1687 125.925 38.1687 125.925C38.1687 125.925 39.1381 104.292 40.6634 95.6105C40.806 94.798 40.9913 93.9569 41.1695 93.1158C40.2957 91.5964 38.9668 90.3897 37.3704 89.666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7537 130.337C59.4665 134.571 62.6597 143.816 62.6597 143.816C62.6597 143.816 60.108 123.858 62.1465 108.562C62.4245 106.509 62.6882 104.449 62.9377 102.411C62.251 99.0472 61.2829 95.7473 60.0438 92.5459C56.8435 115.911 58.0552 126.203 58.7537 130.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.127 161.599C113.523 156.562 112.368 151.393 111.677 146.153C111.104 145.442 110.462 144.79 109.76 144.207C109.845 147.45 109.909 151.092 109.76 154.706C109.909 155.126 110.118 155.522 110.38 155.882C112.083 158.042 115.127 161.599 115.127 161.599Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6637 70.9197L13.5425 70.8056C11.7107 73.1008 11.5183 76.3439 11.0051 79.2734C10.6914 73.3574 11.0977 65.9659 10.7271 58.7598C10.385 72.053 9.30154 79.195 9.62941 82.3597C10.1212 86.9 13.3144 99.4092 13.3144 99.4092C13.3144 99.4092 12.9082 84.9256 13.6637 70.9197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.429 158.94C145.855 160.18 146.81 160.879 146.81 160.879C146.81 160.879 146.14 159.325 145.092 156.873C144.885 157.564 144.693 158.256 144.429 158.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.114 162.525C129.24 163.908 130.074 164.792 130.074 164.792C130.074 164.792 129.468 162.653 128.648 159.603C128.47 160.558 128.299 161.548 128.114 162.525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36191 50.791C4.19085 52.6157 4.03404 54.4262 3.71329 56.1297C2.70828 61.4826 0.128043 68.1827 0.569962 73.8777C2.9435 80.8415 5.97278 88.1332 5.97278 88.1332C5.97278 88.1332 4.83947 70.1214 4.40468 53.0719C4.39043 52.3306 4.37617 51.5751 4.36191 50.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4424 117.079C30.6127 118.192 30.9719 119.267 31.5044 120.258C31.5044 120.258 31.0411 118.911 30.4424 117.079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3986 96.2729C17.9332 99.4376 20.378 109.103 20.378 109.103C20.378 109.103 21.2903 96.1019 22.4094 84.0061C21.1461 81.2797 19.7179 78.6328 18.1327 76.0801C17.2418 87.6983 17.0493 94.1988 17.3986 96.2729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8557 103.537C31.3617 100.685 32.0745 97.6348 32.7873 94.4772C31.8127 93.4077 30.6352 92.5428 29.3232 91.9326C28.3609 100.201 27.4201 105.675 27.7979 107.813C28.5208 110.947 29.4107 114.04 30.4636 117.079C29.9362 114.485 29.6368 110.158 30.8557 103.537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0261 118.875C74.3134 115.981 73.6006 112.246 72.7666 108.525C71.9826 115.454 71.2556 120.928 71.3411 124.406C71.5264 131.99 75.3968 150.066 75.3968 150.066C75.3968 150.066 72.5599 130.443 75.0261 118.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.484 132.183C81.2904 133.645 81.2237 135.121 81.2844 136.595C81.7334 142.496 87.4428 155.398 87.4428 155.398C87.4428 155.398 87.179 151.427 87.0579 145.775C85.0193 141.399 83.2018 136.801 81.484 132.183Z",
    fill: "black"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1814 339.8H350",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.977 230.197C135.963 230.197 147.302 218.858 147.302 204.872C147.302 190.885 135.963 179.547 121.977 179.547C107.99 179.547 96.6521 190.885 96.6521 204.872C96.6521 218.858 107.99 230.197 121.977 230.197Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.439 63.429L152.312 44.9754L161.343 63.429C161.343 63.429 164.736 52.8871 166.24 48.7459C167.744 44.6047 169.248 41.2119 169.248 41.2119L173.767 63.0513L183.931 47.2277L186.946 59.6513L185.813 72.075H154.194L153.439 63.429Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.416 95.4258C147.416 95.4258 143.652 84.5061 140.288 75.4681C136.924 66.4302 129.746 55.5105 129.746 55.5105C129.746 55.5105 136.852 62.2961 141.015 66.4729C144.145 69.7689 147.041 73.2796 149.682 76.9792C149.682 76.9792 147.423 64.9333 145.541 59.2882C143.659 53.643 139.126 41.2123 139.126 41.2123C139.126 41.2123 149.668 52.1319 152.305 54.7549C154.05 56.5337 155.683 58.4191 157.195 60.4001L154.935 45.717L163.218 59.2597L168.877 67.1857C168.877 67.1857 172.263 56.6438 174.9 52.1248C177.538 47.6058 180.545 43.4646 181.315 42.3384C182.085 41.2123 177.908 60.058 177.908 60.058L189.598 41.2123L195.621 33.3076C195.621 33.3076 190.31 57.3993 190.31 62.2961C190.31 67.1928 188.429 73.2158 188.429 73.2158L197.089 55.147C197.735 63.2971 197.608 71.4901 196.711 79.6165C195.207 92.0401 195.963 93.544 193.325 100.323C190.688 107.101 187.303 115.383 187.303 115.383L183.931 119.931L155.32 118.805L147.416 95.4258Z",
    fill: "#BDBDBD",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.542 117.265C148.542 117.265 138.378 102.204 137.63 95.0479C136.881 87.8917 134.615 76.9791 134.615 76.9791C137.809 81.6058 141.609 85.7841 145.912 89.4028C150.148 92.9473 153.939 96.992 157.202 101.449C156.564 96.8314 156.196 92.1811 156.097 87.5211C156.097 81.4981 158.357 71.334 158.357 71.334C158.357 71.334 168.143 91.2916 170.025 95.8035C170.025 95.8035 173.411 88.2766 176.44 84.1354C179.469 79.9942 185.849 72.0824 185.849 72.0824C185.849 72.0824 184.829 87.7278 186.604 93.1662C188.379 98.6047 187.36 115.383 187.36 115.383C187.36 115.383 196.02 95.8035 198.279 91.2845C200.539 86.7655 212.955 75.4752 212.955 75.4752C212.955 75.4752 208.444 91.6623 207.31 97.3074C206.317 101.8 204.669 106.123 202.421 110.137C201.665 111.271 199.783 115.412 199.783 115.412L191.501 128.955L182.841 139.496L159.12 137.615L148.542 117.265Z",
    fill: "#BDBDBD",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.793 125.169C143.664 121.509 140.551 116.844 138.755 111.627C136.118 103.344 134.614 97.6992 134.614 97.6992C134.614 97.6992 141.029 103.344 146.282 108.619C151.535 113.893 160.595 120.287 160.595 120.287C160.595 120.287 160.217 108.619 162.477 100.329C164.736 92.0398 167.744 83.3867 167.744 83.3867C167.744 83.3867 175.278 112.753 176.026 116.516C176.775 120.28 177.331 124.271 177.331 124.271C177.331 124.271 180.895 103.715 183.56 98.0698C186.226 92.4247 190.332 85.6462 190.332 85.6462C190.332 85.6462 189.954 103.715 190.332 109.738C190.548 114.012 190.548 118.294 190.332 122.568C190.332 122.568 193.347 116.545 197.11 112.781C200.874 109.018 220.831 99.2388 220.831 99.2388C220.831 99.2388 209.156 110.158 207.289 113.173C205.421 116.189 189.697 131.52 189.697 131.52L153.816 133.473L147.793 125.169Z",
    fill: "#BDBDBD",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.641 139.61C155.641 139.61 138.784 146.082 129.582 170.972C120.38 195.862 123.281 222.577 128.869 234.33C134.458 246.084 144.194 256.476 165.656 257.667C187.117 258.857 201.936 254.773 211.473 233.482C221.01 212.192 219.313 186.981 214.203 171.82C209.092 156.66 198.037 146.816 193.76 143.381C185.963 137.037 166.882 132.625 155.641 139.61Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.472 184.536C163.189 187.972 163.503 188.599 163.503 189.383",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.406 192.349C145.189 189.084 146.192 185.855 148.221 183.289C151.657 178.756 152.277 177.822 154.465 178.3C156.333 178.699 158.892 180.438 160.666 183.118",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M158.82 178.293C159.923 176.209 161.347 174.311 163.04 172.669C164.156 171.547 165.347 170.501 166.604 169.54C166.604 169.54 174.565 172.512 175.97 177.979",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.848 188.285C175.848 188.285 174.423 184.85 175.535 182.975C176.647 181.101 178.186 176.881 181.002 177.508C183.817 178.136 189.747 178.756 190.838 182.975",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.413 198.6C162.413 198.6 163.04 192.663 165.378 190.631C167.716 188.6 171.158 186.568 171.472 186.098C171.786 185.628 177.409 188.286 179.747 191.879C182.085 195.471 181.622 197.346 181.622 197.346",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.409 205.784C178.438 203.74 179.585 201.757 180.845 199.847",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.033 197.659C183.033 197.659 184.459 194.537 186.312 194.85C188.165 195.164 193.183 198.129 194.152 200.004C194.668 200.916 194.986 201.926 195.086 202.969",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M190.531 194.38C190.531 194.38 189.904 189.39 191.622 186.881C193.339 184.373 192.869 183.603 194.587 182.819C196.305 182.035 201.465 184.38 202.242 187.352",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138.463 196.669C139.89 195.276 141.212 193.78 142.419 192.192C143.999 193.946 145.723 195.565 147.572 197.032C149.136 198.207 150.284 199.85 150.851 201.722",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M136.14 200.624C136.14 200.624 135.783 199.426 137.166 197.865",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.698 205.071C166.889 207.423 166.782 208.436 166.782 208.436",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M151.935 203.411C152.465 202.382 153.153 201.442 153.973 200.624C156.162 198.75 156.475 197.973 156.475 197.973C156.475 197.973 162.256 199.398 164.601 203.126",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.97 209.69C148.97 209.69 149.568 208.15 150.431 206.312",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.287 215.001C165.879 212.417 167.936 210.151 170.353 208.315C173.917 205.821 179.412 208.159 182.22 212.221",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M191.622 212.656C191.622 212.656 193.162 204.038 196.775 201.9C200.389 199.762 205.835 200.182 206.754 207.21",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M203.496 198.13C202.968 196.073 203.246 193.893 204.273 192.035C205.991 188.6 206.462 188.286 206.932 188.129C207.402 187.973 209.27 188.443 210.988 190.474C212.001 191.652 212.843 192.967 213.49 194.38",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M206.704 174.501C207.656 175.702 208.52 176.969 209.291 178.293",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.807 181.229C198.273 179.373 198.384 177.391 199.12 175.605C199.764 174.061 200.66 172.635 201.772 171.386C202.849 171.798 203.887 172.306 204.872 172.904",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.596 172.633C183.453 171.522 183.636 170.392 184.124 169.383C185.231 167.578 186.6 165.947 188.187 164.544C188.657 164.23 190.532 165.171 192.406 166.732C194.281 168.293 195.214 169.226 195.528 171.258",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.437 176.724C184.149 175.839 183.925 174.933 183.767 174.016",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.507 169.384C168.349 168.545 168.365 167.683 168.552 166.851C168.74 166.019 169.095 165.234 169.597 164.544C171.315 162.042 175.378 158.129 175.378 158.129C175.378 158.129 180.217 160.153 181.793 162.185C182.849 163.704 183.642 165.391 184.138 167.174",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M202.991 163.888C203.932 166.375 204.416 168.293 204.416 168.293",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M193.026 164.073C193.026 164.073 190.218 161.264 192.092 157.986C193.967 154.707 195.214 154.422 195.214 154.422C197.824 155.552 199.973 157.535 201.308 160.046C201.586 160.602 201.85 161.165 202.092 161.721",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M160.559 165.599C160.852 165.89 161.106 166.219 161.315 166.575C162.569 168.763 162.099 172.042 162.099 172.042",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M146.325 172.355C146.325 172.355 146.945 167.979 148.357 166.888C149.768 165.798 154.6 161.271 154.6 161.271C156.33 162.268 157.979 163.398 159.533 164.65",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M137.608 177.096C139.484 175.209 141.454 173.418 143.51 171.729C143.51 171.729 145.384 171.885 146.788 175.007C147.661 176.997 148.239 179.102 148.506 181.258",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M135.234 183.602C135.04 182.827 135.009 182.021 135.143 181.233C135.276 180.445 135.572 179.694 136.011 179.026",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.012 194.537C129.012 194.537 127.765 190.973 129.012 188.756C130.259 186.539 133.545 183.767 133.545 183.767C133.545 183.767 135.263 184.544 136.667 187.665C137.502 189.477 137.928 191.451 137.914 193.446",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.294 170.951C134.294 170.951 134.294 167.665 136.482 165.634C137.704 164.477 139.07 163.48 140.545 162.669C140.545 162.669 141.792 165.634 141.008 168.293C140.721 169.409 140.356 170.505 139.917 171.571",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.949 161.272C141.949 161.272 142.882 160.174 145.855 158.421C147.479 157.45 149.208 156.666 151.008 156.083C151.401 157.468 151.715 158.875 151.949 160.295C152.02 161.207 151.858 162.122 151.479 162.954",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.778 159.846C171.778 159.846 169.277 154.222 167.872 153.125C166.468 152.027 161.008 155.17 158.948 159.846",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M182.092 219.056C183.81 216.718 187.246 211.871 187.559 211.408C187.873 210.945 191.936 211.558 195.058 215.464C196.923 217.792 198.063 220.618 198.336 223.589",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M180.374 225.464C180.403 223.785 180.711 222.123 181.287 220.546",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M208.686 224.587C208.899 225.284 209.042 226 209.113 226.725",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M196.932 232.178C196.932 232.178 196.775 222.962 202.085 220.624C205.058 219.313 206.854 220.781 207.887 222.663",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M204.338 213.403C205.115 210.944 206.391 208.157 208.337 207.188C212.086 205.313 213.647 211.408 213.804 212.812",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M203.34 217.652C203.487 216.692 203.685 215.74 203.931 214.801",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M212.086 205.463C212.086 205.463 211.772 200.474 213.02 197.181C214.267 193.888 215.521 190.153 216.926 190.467",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.013 222.164C169.346 223.342 169.542 224.555 169.597 225.778",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M154.13 227.966C154.13 227.966 154.6 222.029 156.789 218.9C158.977 215.771 159.91 215.158 161.315 215.001C162.541 214.865 166.468 217.196 168.093 219.755",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M167.566 235.613C167.566 235.613 169.284 227.495 174.594 225.635C179.904 223.774 184.573 229.384 184.573 232.349V236.112",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M144.451 238.116C144.451 238.116 143.51 233.739 147.573 229.527C151.635 225.314 158.036 230.774 158.82 234.21",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.553 225.072C145.74 223.431 144.597 221.975 143.196 220.795C140.074 218.3 137.886 218.921 135.234 222.363C132.583 225.806 132.419 228.45 132.576 229.862",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M147.544 227.495C147.377 226.965 147.177 226.446 146.945 225.941",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.105 213.903C143.666 211.094 144.45 209.997 145.669 209.84C146.888 209.683 151.45 208.592 153.638 215.464",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M140.416 218.122C140.579 217.263 140.86 216.431 141.25 215.648",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.883 208.436C142.883 208.436 135.541 198.75 133.203 201.095C130.865 203.44 129.639 207.659 129.454 210.624",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M186.155 243.896C186.155 243.896 186.155 239.833 187.873 237.959C189.914 235.976 192.055 234.099 194.288 232.335C194.288 232.335 199.441 235.307 199.904 237.802C200.19 239.243 200.243 240.721 200.061 242.178",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M157.751 245.643C157.575 246.769 157.513 247.911 157.566 249.05",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M173.974 249.833C173.799 247.302 173.048 244.845 171.778 242.649C169.747 239.363 164.9 237.802 164.9 237.802C164.9 237.802 161.001 238.899 159.127 241.708C158.787 242.224 158.512 242.779 158.307 243.361",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M150.538 247.018C150.538 247.018 147.886 241.865 145.855 240.774C143.824 239.684 139.761 239.057 138.014 240.618",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.761 252.328C150.188 251.065 151.007 249.972 152.099 249.206C153.824 248.116 161.785 250.924 163.503 252.77C165.221 254.616 165.363 256.07 165.363 256.07",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M178.236 245.379C179.959 243.878 181.826 242.551 183.81 241.416C185.2 243.152 186.832 244.678 188.657 245.949C191.152 247.51 190.681 251.259 190.375 251.887",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M176.625 254.987C176.625 254.987 174.28 252.022 175.691 248.572C175.95 247.982 176.29 247.433 176.704 246.939",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M152.683 136.838C152.683 136.838 139.14 121.029 131.228 117.636L123.31 114.229C128.81 115.16 134.225 116.545 139.497 118.37C144.831 120.265 149.799 123.067 154.18 126.652C153.279 123.176 153.41 119.513 154.558 116.11C155.726 112.394 157.109 108.748 158.699 105.191C158.699 105.191 162.462 113.103 163.966 116.11C165.47 119.118 166.981 123.238 166.981 123.238C166.981 123.238 168.485 119.475 170.745 113.074C173.004 106.673 176.055 104.086 176.055 104.086C176.055 104.086 175.306 112.746 176.055 116.51L176.81 120.273C176.81 120.273 182.078 117.636 183.589 116.132C185.1 114.628 195.257 110.109 195.257 110.109L192.62 118.014C192.043 119.602 191.285 121.118 190.36 122.532C190.36 122.532 197.488 119.147 202.784 118.391C206.549 117.987 210.352 118.115 214.081 118.769C214.081 118.769 198.643 124.036 192.62 134.956L188.856 141.371L180.574 135.348L167.395 142.875L163.225 137.593L152.683 136.838Z",
    fill: "#CCCCCC",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M155.641 139.61C155.641 139.61 151.593 140.223 149.02 135.077C146.447 129.931 140.787 125.298 140.787 125.298C140.787 125.298 149.533 128.897 151.08 129.931C152.74 130.895 154.458 131.754 156.226 132.504L159.832 123.751L170.125 131.47L177.331 124.264L180.417 132.504L190.717 125.811L189.683 131.47C189.683 131.47 194.316 129.418 195.863 128.897C197.41 128.377 204.609 127.358 204.609 127.358C204.609 127.358 198.436 131.991 195.863 136.103C193.29 140.216 193.796 143.359 193.796 143.359L196.376 149.489L188.657 146.916L180.417 155.662L169.612 146.396L156.739 153.609L159.319 145.369L154.166 145.883L155.641 139.61Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M213.39 205.542C204.302 196.355 195.036 195.963 190.46 199.006C188.571 200.261 185.136 202.933 181.75 205.649C181.75 205.093 181.736 204.38 181.707 203.511C181.665 201.223 180.631 198.008 179.569 196.796C178.507 195.585 177.894 196.119 177.21 196.362C176.526 196.604 178.372 199.106 179.348 202.884C180.211 206.155 179.419 207.395 179.191 207.673C175.364 210.774 172.149 213.454 172.149 213.454C172.149 213.454 164.358 217.503 170.56 233.005C174.957 243.989 190.581 252.35 200.332 250.682C210.083 249.014 213.875 242.058 213.875 242.058C213.875 242.058 218.458 239.014 220.29 234.745C222.122 230.475 227.047 219.363 213.39 205.542Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M194.003 184.279C194.003 184.279 195.214 183.217 194.209 179.432C193.204 175.648 191.358 173.153 192.071 172.911C192.784 172.668 193.361 172.134 194.43 173.345C195.499 174.557 196.533 177.765 196.569 180.06C196.604 182.355 196.633 183.588 196.633 183.588C196.633 183.588 194.224 185.534 193.668 185.306C193.112 185.078 194.003 184.279 194.003 184.279Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M187.018 189.997C187.018 189.997 179.227 194.052 185.428 209.555C189.826 220.539 205.443 228.9 215.201 227.232C224.958 225.564 228.743 218.607 228.743 218.607C228.743 218.607 233.319 215.564 235.158 211.294C236.997 207.025 241.887 195.884 228.223 182.071C219.149 172.883 209.883 172.491 205.279 175.527C200.674 178.564 187.018 189.997 187.018 189.997Z",
    fill: "#8C8C8C",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M265.906 169.767C266.942 165.542 264.357 161.277 260.133 160.241C255.908 159.205 251.643 161.79 250.607 166.015C249.571 170.239 252.156 174.504 256.38 175.54C260.605 176.576 264.87 173.991 265.906 169.767Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M259.169 173.546C259.906 169.259 257.029 165.186 252.742 164.449C248.455 163.711 244.382 166.589 243.645 170.876C242.907 175.162 245.785 179.235 250.072 179.973C254.359 180.71 258.432 177.833 259.169 173.546Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M247.208 170.169C247.907 165.876 244.993 161.829 240.7 161.13C236.407 160.431 232.359 163.344 231.66 167.637C230.961 171.931 233.874 175.978 238.168 176.677C242.461 177.376 246.508 174.463 247.208 170.169Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M233.213 185.57C237.562 185.57 241.089 182.043 241.089 177.694C241.089 173.344 237.562 169.817 233.213 169.817C228.863 169.817 225.336 173.344 225.336 177.694C225.336 182.043 228.863 185.57 233.213 185.57Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M228.862 183.733C229.857 179.498 227.23 175.259 222.996 174.264C218.761 173.269 214.522 175.896 213.527 180.13C212.533 184.365 215.159 188.604 219.393 189.599C223.628 190.594 227.867 187.967 228.862 183.733Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M244.909 200.143C245.913 195.911 243.296 191.665 239.064 190.661C234.832 189.657 230.587 192.273 229.582 196.506C228.578 200.738 231.195 204.983 235.427 205.988C239.659 206.992 243.905 204.375 244.909 200.143Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M248.124 221.226C251.2 218.15 251.2 213.163 248.124 210.087C245.048 207.011 240.061 207.011 236.985 210.087C233.909 213.163 233.909 218.15 236.985 221.226C240.061 224.301 245.048 224.301 248.124 221.226Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M251.423 238.586C255.773 238.586 259.3 235.06 259.3 230.71C259.3 226.36 255.773 222.834 251.423 222.834C247.074 222.834 243.547 226.36 243.547 230.71C243.547 235.06 247.074 238.586 251.423 238.586Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M280.744 237.702C281.749 233.47 279.132 229.225 274.9 228.22C270.667 227.216 266.422 229.833 265.418 234.065C264.413 238.298 267.03 242.543 271.262 243.547C275.495 244.551 279.74 241.935 280.744 237.702Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M255.603 247.657C259.617 245.981 261.512 241.369 259.836 237.355C258.16 233.341 253.548 231.445 249.534 233.121C245.52 234.797 243.624 239.409 245.3 243.423C246.976 247.438 251.588 249.333 255.603 247.657Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M260.29 227.66C264.64 227.66 268.166 224.133 268.166 219.783C268.166 215.433 264.64 211.907 260.29 211.907C255.94 211.907 252.414 215.433 252.414 219.783C252.414 224.133 255.94 227.66 260.29 227.66Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M261.73 214.872C266.08 214.872 269.606 211.346 269.606 206.996C269.606 202.646 266.08 199.12 261.73 199.12C257.38 199.12 253.854 202.646 253.854 206.996C253.854 211.346 257.38 214.872 261.73 214.872Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M265.237 207.452C269.587 207.452 273.113 203.926 273.113 199.576C273.113 195.226 269.587 191.7 265.237 191.7C260.887 191.7 257.361 195.226 257.361 199.576C257.361 203.926 260.887 207.452 265.237 207.452Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M261.524 196.725C265.873 196.725 269.4 193.199 269.4 188.849C269.4 184.499 265.873 180.973 261.524 180.973C257.174 180.973 253.647 184.499 253.647 188.849C253.647 193.199 257.174 196.725 261.524 196.725Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M215.866 173.5C219.88 171.824 221.776 167.212 220.1 163.197C218.424 159.183 213.812 157.288 209.797 158.964C205.783 160.64 203.888 165.252 205.564 169.266C207.24 173.28 211.852 175.176 215.866 173.5Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M226.544 175.519C227.694 170.674 224.699 165.814 219.855 164.663C215.01 163.513 210.149 166.507 208.998 171.352C207.848 176.197 210.843 181.058 215.688 182.208C220.533 183.359 225.393 180.364 226.544 175.519Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M226.86 182.099C229.935 179.023 229.936 174.036 226.86 170.96C223.784 167.884 218.797 167.884 215.721 170.96C212.645 174.036 212.645 179.023 215.721 182.099C218.797 185.174 223.784 185.174 226.86 182.099Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M221.494 165.156C225.006 165.156 227.852 162.31 227.852 158.798C227.852 155.287 225.006 152.44 221.494 152.44C217.983 152.44 215.136 155.287 215.136 158.798C215.136 162.31 217.983 165.156 221.494 165.156Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M234.096 184.735C237.608 184.735 240.454 181.889 240.454 178.377C240.454 174.866 237.608 172.02 234.096 172.02C230.585 172.02 227.738 174.866 227.738 178.377C227.738 181.889 230.585 184.735 234.096 184.735Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M240.353 195.514C243.785 192.841 244.402 187.893 241.73 184.46C239.057 181.028 234.109 180.412 230.676 183.084C227.244 185.756 226.628 190.704 229.3 194.137C231.972 197.569 236.92 198.186 240.353 195.514Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M244.795 185.649C249.145 185.649 252.671 182.122 252.671 177.773C252.671 173.423 249.145 169.896 244.795 169.896C240.445 169.896 236.919 173.423 236.919 177.773C236.919 182.122 240.445 185.649 244.795 185.649Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M239.232 162.304C242.308 159.228 242.308 154.241 239.232 151.165C236.156 148.089 231.17 148.089 228.094 151.165C225.018 154.241 225.018 159.228 228.094 162.304C231.17 165.379 236.156 165.379 239.232 162.304Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M269.535 182.555C273.885 182.555 277.411 179.029 277.411 174.679C277.411 170.329 273.885 166.803 269.535 166.803C265.185 166.803 261.659 170.329 261.659 174.679C261.659 179.029 265.185 182.555 269.535 182.555Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M255.353 164.341C256.357 160.109 253.74 155.864 249.508 154.859C245.276 153.855 241.03 156.472 240.026 160.704C239.022 164.936 241.639 169.181 245.871 170.186C250.103 171.19 254.348 168.573 255.353 164.341Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M267.932 178.957C268.927 174.723 266.301 170.484 262.066 169.489C257.832 168.494 253.592 171.12 252.598 175.355C251.603 179.59 254.229 183.829 258.464 184.824C262.698 185.818 266.938 183.192 267.932 178.957Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M277.932 188.938C278.631 184.645 275.718 180.597 271.424 179.898C267.131 179.199 263.084 182.113 262.385 186.406C261.685 190.699 264.599 194.747 268.892 195.446C273.186 196.145 277.233 193.231 277.932 188.938Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M256.595 188.054C257.599 183.822 254.983 179.576 250.75 178.572C246.518 177.568 242.273 180.184 241.268 184.417C240.264 188.649 242.881 192.894 247.113 193.899C251.345 194.903 255.591 192.286 256.595 188.054Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M235.804 173.582C239.879 172.061 241.95 167.525 240.43 163.449C238.909 159.374 234.373 157.303 230.297 158.823C226.222 160.344 224.151 164.88 225.671 168.955C227.192 173.031 231.728 175.102 235.804 173.582Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M248.972 207.596C252.907 205.742 254.595 201.05 252.741 197.115C250.888 193.179 246.195 191.492 242.26 193.345C238.325 195.199 236.637 199.891 238.491 203.827C240.344 207.762 245.037 209.449 248.972 207.596Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M248.508 220.082C252.858 220.082 256.385 216.556 256.385 212.206C256.385 207.856 252.858 204.33 248.508 204.33C244.159 204.33 240.632 207.856 240.632 212.206C240.632 216.556 244.159 220.082 248.508 220.082Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M273.189 212.26C277.204 210.584 279.099 205.971 277.423 201.957C275.747 197.943 271.135 196.048 267.121 197.723C263.107 199.399 261.211 204.012 262.887 208.026C264.563 212.04 269.175 213.936 273.189 212.26Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M280.312 220.534C281.333 215.527 278.103 210.639 273.095 209.617C268.088 208.595 263.2 211.826 262.178 216.834C261.156 221.841 264.387 226.729 269.394 227.751C274.402 228.773 279.29 225.542 280.312 220.534Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356458,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M275.044 190.585C275.743 186.291 272.83 182.244 268.536 181.545C264.243 180.846 260.196 183.759 259.496 188.052C258.797 192.346 261.711 196.393 266.004 197.092C270.298 197.791 274.345 194.878 275.044 190.585Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M249.064 180.217C253.414 180.217 256.94 176.691 256.94 172.341C256.94 167.991 253.414 164.465 249.064 164.465C244.714 164.465 241.188 167.991 241.188 172.341C241.188 176.691 244.714 180.217 249.064 180.217Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M262.158 203.995C266.508 203.995 270.034 200.469 270.034 196.119C270.034 191.769 266.508 188.243 262.158 188.243C257.808 188.243 254.282 191.769 254.282 196.119C254.282 200.469 257.808 203.995 262.158 203.995Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M266.845 219.868C267.544 215.574 264.63 211.527 260.337 210.828C256.044 210.129 251.996 213.042 251.297 217.336C250.598 221.629 253.512 225.676 257.805 226.375C262.098 227.075 266.146 224.161 266.845 219.868Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M278.159 234.899C280.769 231.419 280.063 226.482 276.583 223.872C273.103 221.262 268.167 221.967 265.557 225.447C262.947 228.927 263.652 233.864 267.132 236.474C270.612 239.084 275.549 238.378 278.159 234.899Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M255.84 241.982C259.772 240.123 261.452 235.427 259.593 231.495C257.733 227.563 253.038 225.883 249.105 227.742C245.173 229.602 243.493 234.297 245.353 238.229C247.212 242.162 251.907 243.842 255.84 241.982Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M229.577 198.015C233.927 198.015 237.453 194.489 237.453 190.139C237.453 185.789 233.927 182.263 229.577 182.263C225.227 182.263 221.701 185.789 221.701 190.139C221.701 194.489 225.227 198.015 229.577 198.015Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M248.138 209.109C251.214 206.033 251.214 201.047 248.138 197.971C245.063 194.895 240.076 194.895 237 197.971C233.924 201.047 233.924 206.033 237 209.109C240.076 212.185 245.063 212.185 248.138 209.109Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M255.515 207.502C259.865 207.502 263.391 203.976 263.391 199.626C263.391 195.276 259.865 191.75 255.515 191.75C251.165 191.75 247.639 195.276 247.639 199.626C247.639 203.976 251.165 207.502 255.515 207.502Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M270.937 235.253C271.814 230.144 268.383 225.29 263.273 224.413C258.164 223.536 253.31 226.968 252.433 232.077C251.556 237.187 254.987 242.04 260.097 242.917C265.207 243.794 270.06 240.363 270.937 235.253Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M258.815 221.522C262.48 221.522 265.451 218.551 265.451 214.886C265.451 211.221 262.48 208.25 258.815 208.25C255.15 208.25 252.179 211.221 252.179 214.886C252.179 218.551 255.15 221.522 258.815 221.522Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M250.155 230.803C253.82 230.803 256.791 227.832 256.791 224.167C256.791 220.502 253.82 217.531 250.155 217.531C246.49 217.531 243.519 220.502 243.519 224.167C243.519 227.832 246.49 230.803 250.155 230.803Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M235.45 162.526C235.492 162.955 235.403 163.387 235.195 163.765C234.986 164.142 234.669 164.448 234.284 164.642C233.898 164.836 233.463 164.909 233.036 164.851C232.609 164.794 232.209 164.608 231.889 164.319C231.568 164.03 231.343 163.651 231.243 163.231C231.142 162.812 231.17 162.372 231.324 161.969C231.478 161.566 231.751 161.219 232.105 160.974C232.46 160.728 232.881 160.596 233.312 160.594C233.851 160.569 234.378 160.758 234.779 161.119C235.179 161.481 235.421 161.987 235.45 162.526Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M236.954 152.441C236.996 152.87 236.907 153.302 236.698 153.68C236.49 154.057 236.173 154.363 235.787 154.557C235.402 154.751 234.967 154.824 234.54 154.766C234.113 154.709 233.713 154.523 233.392 154.234C233.072 153.945 232.847 153.566 232.747 153.146C232.646 152.727 232.674 152.287 232.828 151.884C232.982 151.481 233.255 151.134 233.609 150.889C233.964 150.644 234.385 150.511 234.816 150.509C235.355 150.484 235.882 150.673 236.283 151.034C236.683 151.396 236.925 151.902 236.954 152.441Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M252.421 158.114C252.463 158.543 252.374 158.975 252.166 159.353C251.958 159.73 251.64 160.036 251.255 160.23C250.87 160.424 250.435 160.497 250.007 160.44C249.58 160.382 249.18 160.196 248.86 159.907C248.54 159.618 248.315 159.239 248.214 158.82C248.113 158.4 248.142 157.96 248.296 157.557C248.45 157.154 248.722 156.807 249.076 156.562C249.431 156.317 249.852 156.184 250.283 156.182C250.823 156.155 251.351 156.343 251.752 156.706C252.153 157.068 252.394 157.574 252.421 158.114Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M253.598 170.046C253.639 170.475 253.55 170.907 253.342 171.284C253.134 171.662 252.816 171.968 252.431 172.162C252.046 172.356 251.611 172.429 251.184 172.371C250.756 172.314 250.356 172.128 250.036 171.839C249.716 171.55 249.491 171.171 249.39 170.751C249.289 170.332 249.318 169.892 249.472 169.489C249.626 169.086 249.898 168.739 250.253 168.494C250.607 168.248 251.028 168.116 251.459 168.114C251.999 168.087 252.527 168.275 252.928 168.637C253.329 168.999 253.57 169.506 253.598 170.046Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M265.081 174.101C265.122 174.53 265.033 174.962 264.825 175.34C264.617 175.718 264.299 176.024 263.914 176.218C263.529 176.412 263.094 176.485 262.666 176.427C262.239 176.369 261.839 176.184 261.519 175.895C261.199 175.606 260.974 175.226 260.873 174.807C260.772 174.388 260.801 173.948 260.955 173.545C261.109 173.142 261.381 172.795 261.736 172.549C262.09 172.304 262.511 172.172 262.942 172.17C263.482 172.142 264.01 172.331 264.411 172.693C264.812 173.055 265.053 173.562 265.081 174.101Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M273.74 171.885C273.782 172.314 273.693 172.746 273.485 173.124C273.276 173.502 272.959 173.808 272.574 174.002C272.188 174.196 271.754 174.268 271.326 174.211C270.899 174.153 270.499 173.968 270.179 173.678C269.859 173.389 269.633 173.01 269.533 172.591C269.432 172.171 269.461 171.731 269.614 171.328C269.768 170.926 270.041 170.579 270.395 170.333C270.75 170.088 271.171 169.955 271.602 169.953C272.141 169.928 272.668 170.117 273.069 170.479C273.469 170.841 273.711 171.346 273.74 171.885Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M273.52 186.932C273.563 187.361 273.475 187.793 273.268 188.172C273.061 188.551 272.744 188.858 272.359 189.053C271.974 189.248 271.539 189.322 271.111 189.265C270.683 189.208 270.283 189.024 269.962 188.735C269.641 188.446 269.415 188.067 269.314 187.648C269.212 187.228 269.24 186.788 269.394 186.384C269.548 185.981 269.82 185.634 270.174 185.388C270.529 185.142 270.95 185.009 271.382 185.007C271.919 184.982 272.446 185.17 272.846 185.53C273.246 185.89 273.489 186.394 273.52 186.932Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M267.439 192.426C267.481 192.856 267.392 193.288 267.184 193.665C266.976 194.043 266.658 194.349 266.273 194.543C265.888 194.737 265.453 194.81 265.025 194.752C264.598 194.695 264.198 194.509 263.878 194.22C263.558 193.931 263.333 193.552 263.232 193.132C263.131 192.713 263.16 192.273 263.314 191.87C263.468 191.467 263.74 191.12 264.095 190.875C264.449 190.629 264.87 190.497 265.301 190.495C265.841 190.468 266.369 190.656 266.77 191.018C267.171 191.38 267.412 191.887 267.439 192.426Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M260.105 196.198C260.148 196.627 260.06 197.059 259.853 197.438C259.646 197.817 259.329 198.124 258.944 198.319C258.559 198.514 258.124 198.588 257.696 198.531C257.268 198.474 256.868 198.29 256.547 198.001C256.226 197.712 256 197.333 255.899 196.914C255.797 196.494 255.825 196.054 255.979 195.65C256.133 195.247 256.405 194.9 256.759 194.654C257.114 194.408 257.535 194.275 257.966 194.273C258.505 194.246 259.032 194.433 259.433 194.794C259.834 195.155 260.075 195.659 260.105 196.198Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M254.325 185.064C254.368 185.493 254.28 185.926 254.073 186.304C253.865 186.683 253.549 186.99 253.164 187.185C252.779 187.38 252.344 187.454 251.916 187.397C251.488 187.341 251.087 187.156 250.766 186.867C250.446 186.578 250.22 186.199 250.118 185.78C250.017 185.36 250.045 184.92 250.199 184.517C250.352 184.113 250.624 183.766 250.979 183.52C251.334 183.274 251.755 183.141 252.186 183.139C252.725 183.112 253.252 183.299 253.653 183.66C254.053 184.021 254.295 184.525 254.325 185.064Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M234.018 187.851C234.059 188.28 233.97 188.712 233.762 189.09C233.554 189.467 233.236 189.773 232.851 189.967C232.466 190.161 232.031 190.234 231.603 190.177C231.176 190.119 230.776 189.933 230.456 189.644C230.136 189.355 229.911 188.976 229.81 188.557C229.709 188.137 229.738 187.697 229.892 187.294C230.046 186.891 230.318 186.544 230.673 186.299C231.027 186.054 231.448 185.921 231.879 185.919C232.418 185.894 232.946 186.083 233.346 186.445C233.747 186.806 233.988 187.312 234.018 187.851Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M223.668 175.028C223.711 175.458 223.624 175.89 223.416 176.269C223.209 176.647 222.892 176.954 222.507 177.149C222.122 177.345 221.687 177.419 221.259 177.362C220.832 177.305 220.431 177.12 220.11 176.832C219.789 176.543 219.563 176.164 219.462 175.744C219.361 175.325 219.389 174.884 219.542 174.481C219.696 174.078 219.968 173.73 220.323 173.484C220.678 173.239 221.098 173.106 221.53 173.104C222.068 173.079 222.594 173.266 222.995 173.627C223.395 173.987 223.637 174.491 223.668 175.028Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M223.989 156.147C224.031 156.577 223.942 157.009 223.734 157.386C223.525 157.764 223.208 158.07 222.823 158.264C222.437 158.458 222.003 158.531 221.575 158.473C221.148 158.416 220.748 158.23 220.428 157.941C220.108 157.652 219.882 157.273 219.782 156.853C219.681 156.434 219.71 155.994 219.864 155.591C220.017 155.188 220.29 154.841 220.644 154.596C220.999 154.35 221.42 154.218 221.851 154.216C222.39 154.192 222.916 154.382 223.316 154.743C223.716 155.105 223.958 155.609 223.989 156.147Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M277.048 215.486C277.09 215.915 277 216.347 276.792 216.724C276.584 217.102 276.266 217.408 275.881 217.602C275.496 217.796 275.061 217.869 274.634 217.811C274.206 217.754 273.806 217.568 273.486 217.279C273.166 216.99 272.941 216.611 272.84 216.191C272.74 215.772 272.768 215.332 272.922 214.929C273.076 214.526 273.348 214.179 273.703 213.934C274.058 213.688 274.478 213.556 274.91 213.554C275.449 213.529 275.976 213.718 276.377 214.079C276.777 214.441 277.018 214.947 277.048 215.486Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9872 154.251C66.6158 155.997 64.285 162.491 64.0855 167.715C63.5224 180.595 71.3629 186.753 68.5617 213.083C65.7605 239.413 61.2985 246.69 74.7271 264.054C88.1558 281.417 126.254 281.417 132.975 246.69C139.696 211.964 106.089 191.807 98.2487 186.197C89.2107 179.733 83.6368 168.378 78.0202 159.112C76.4521 156.532 73.4157 152.476 69.9872 154.251Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2682 155.135C72.2682 155.135 69.5169 149.982 69.5169 144.486C69.5169 138.991 71.5768 136.581 68.4834 137.273C65.39 137.964 65.0478 140.359 65.39 144.486C65.7321 148.613 66.7656 154.109 68.8255 156.511C70.8855 158.913 72.2682 155.135 72.2682 155.135Z",
    fill: "#BDBDBD",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M112.464 262.691C124.473 257.601 130.082 243.738 124.991 231.729C119.9 219.72 106.038 214.111 94.0284 219.202C82.0191 224.293 76.4107 238.155 81.5016 250.165C86.5924 262.174 100.455 267.782 112.464 262.691Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.356119,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M103.922 222.421C103.922 223.775 102.497 224.873 100.708 224.873C98.9187 224.873 97.4932 223.775 97.4932 222.421C97.4932 221.066 98.9187 219.969 100.708 219.969C102.497 219.969 103.922 221.066 103.922 222.421Z",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M227.545 249.872C239.554 244.781 245.163 230.919 240.072 218.91C234.981 206.9 221.119 201.292 209.109 206.383C197.1 211.474 191.492 225.336 196.583 237.345C201.673 249.355 215.536 254.963 227.545 249.872Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.356119,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M219.064 209.526C219.064 210.88 217.638 211.978 215.849 211.978C214.06 211.978 212.627 210.88 212.627 209.526C212.627 208.172 214.053 207.081 215.849 207.081C217.645 207.081 219.064 208.172 219.064 209.526Z",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M193.618 221.587C193.618 221.587 194.273 230.853 184.793 240.069C175.313 249.285 163.111 254.032 145.349 252.735C127.586 251.438 110.287 241.601 100.194 228.985C92.9161 219.893 89.2215 208.449 89.8093 196.818C90.0801 190.46 89.5954 187.894 90.4508 187.324C91.3061 186.754 94.5349 185.414 95.8607 186.176C96.7913 186.739 97.6546 187.406 98.4338 188.165C98.4338 188.165 95.8464 178.763 92.8884 171.272C89.9304 163.781 91.0495 153.139 91.4201 150.003C91.7908 146.867 93.5941 145.249 95.1123 145.056C96.6305 144.864 97.8707 144.857 98.726 146.76C99.5814 148.663 101.777 153.781 101.777 153.781C101.777 153.781 113.894 165.057 122.711 173.966C125.419 176.689 128.413 179.818 131.314 182.848C140.249 192.266 151.874 198.696 164.601 201.258L164.928 201.323C175.855 203.461 180.424 206.611 181.565 207.082C183.572 207.621 185.684 207.642 187.702 207.143C189.72 206.645 191.579 205.643 193.104 204.231C196.504 200.881 199.693 197.324 202.655 193.582C202.655 193.582 207.474 195.25 209.284 198.571C211.095 201.893 210.945 205.1 210.09 205.699C209.234 206.298 195.121 210.439 192.32 211.929C190.752 212.691 193.618 221.587 193.618 221.587Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4055 188.164C98.4055 188.164 100.287 202.968 125.206 217.345C150.124 231.722 175.891 220.909 179.519 217.466C183.147 214.023 185.706 213.075 187.238 212.79",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5892 189.633L92.4324 194.18",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7754 191.443L96.8018 193.71",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4119 150.024C95.4119 150.024 93.6015 154.686 102.162 172.626",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M169.326 215.079C174.972 215.457 177.067 214.174 177.067 214.174",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M110.181 184.687C115.462 190.595 124.793 198.75 140.295 206.013C150.93 211.002 158.756 213.39 164.394 214.438",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M104.215 176.425C105.236 178.363 106.449 180.195 107.835 181.892",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4055 197.573C98.4055 197.573 101.435 206.127 119.582 219.634",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M124.536 222.977C124.536 222.977 140.687 233.112 161.7 228.408",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M206.818 202.612C205.391 201.127 203.828 199.779 202.15 198.585C200.845 197.737 202.627 193.524 202.627 193.524C202.627 193.524 207.446 195.192 209.256 198.514C211.067 201.835 210.917 205.043 210.062 205.642C209.294 205.989 208.503 206.284 207.695 206.525C207.652 206.454 207.61 206.397 207.567 206.333C204.83 202.249 207.161 203.147 206.818 202.612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M264.141 250.654C274.782 243.092 277.277 228.337 269.716 217.696C262.154 207.056 247.399 204.56 236.758 212.122C226.118 219.684 223.622 234.439 231.184 245.079C238.745 255.72 253.501 258.216 264.141 250.654Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M268.715 235.143C267.383 234.901 266.577 233.29 266.869 231.544C267.162 229.797 268.523 228.571 269.856 228.814C271.189 229.056 271.994 230.66 271.695 232.413C271.395 234.167 270.02 235.4 268.715 235.143Z",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M111.57 195.399C111.57 195.399 103.338 192.341 96.0034 207.345C90.8144 217.972 95.0982 235.143 102.882 241.28C110.665 247.417 118.356 245.557 118.356 245.557C118.356 245.557 123.68 246.911 128.092 245.414C132.504 243.917 144.03 240.061 145.106 220.667C145.819 207.766 139.896 200.631 134.564 199.284C129.233 197.936 111.57 195.399 111.57 195.399Z",
    fill: "#8C8C8C",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M133.282 218.729C136.612 218.729 139.312 215.694 139.312 211.95C139.312 208.207 136.612 205.172 133.282 205.172C129.951 205.172 127.251 208.207 127.251 211.95C127.251 215.694 129.951 218.729 133.282 218.729Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M119.803 200.567C119.803 200.567 122.098 196.925 124.237 193.646C126.375 190.367 126.981 187.324 127.622 187.666C128.264 188.008 129.048 188.101 128.877 189.705C128.706 191.308 127.009 194.231 125.313 195.799C123.616 197.367 121.863 202.214 121.863 202.214C121.863 202.214 118.798 201.729 118.591 201.166C118.385 200.603 119.803 200.567 119.803 200.567Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M129.518 201.757C130.39 201.541 131.23 201.208 132.013 200.767",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M111.77 198.407C114.15 199.752 116.651 200.871 119.24 201.75C121.786 202.484 124.462 202.652 127.08 202.242",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M266.874 283.596L256.943 297.446L310.838 336.088L320.769 322.238L266.874 283.596Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M266.72 339.8H79.4031C77.3803 339.802 75.4312 339.041 73.9439 337.67C72.4567 336.299 71.5403 334.418 71.3773 332.402L66.6587 274.518C66.6587 272.841 67.3248 271.233 68.5105 270.047C69.6961 268.861 71.3042 268.195 72.981 268.195H273.142C274.817 268.197 276.424 268.864 277.608 270.05C278.792 271.235 279.457 272.842 279.457 274.518L274.746 332.402C274.581 334.417 273.664 336.297 272.177 337.668C270.69 339.039 268.742 339.8 266.72 339.8Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M235.579 288.723H252.037",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M235.579 294.311H252.037",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M235.579 299.906H252.037",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M252.657 307.048H269.115",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M252.657 312.636H269.115",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M252.657 318.225H269.115",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M265.857 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M260.269 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M254.674 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M249.085 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M243.498 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M237.902 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M79.125 288.723H95.5901",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M79.125 294.311H95.5901",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M79.125 299.906H95.5901",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M96.21 307.048H112.668",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2102 312.636H112.668",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2102 318.225H112.668",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7451 324.44H96.2102",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7451 330.028H96.2102",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7451 335.616H96.2102",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M109.411 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M103.815 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2275 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6392 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0439 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4558 304.098V320.556",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M169.284 323.229H185.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M169.284 328.816H185.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M169.284 334.411H185.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M165.706 320.277V336.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M160.117 320.277V336.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M154.529 320.277V336.742",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 288.723H128.819",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 294.311H128.819",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M112.362 299.906H128.819",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M142.64 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M137.052 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M131.457 286.085V302.543",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M279.457 281.581H66.6585L61.0562 240.24C61.058 238.564 61.725 236.958 62.9104 235.774C64.0959 234.59 65.7029 233.925 67.3784 233.925H278.737C280.413 233.925 282.02 234.59 283.205 235.774C284.39 236.958 285.057 238.564 285.059 240.24L279.457 281.581Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M167.506 283.226L163.305 299.742L316.776 338.776L320.977 322.259L167.506 283.226Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M174.344 294.061C174.344 293.548 174.192 293.046 173.907 292.619C173.621 292.192 173.215 291.86 172.741 291.664C172.266 291.467 171.744 291.416 171.241 291.517C170.738 291.618 170.275 291.866 169.913 292.229C169.55 292.593 169.304 293.056 169.204 293.559C169.105 294.063 169.157 294.585 169.355 295.059C169.552 295.533 169.886 295.938 170.314 296.222C170.741 296.506 171.243 296.657 171.757 296.656C172.444 296.654 173.102 296.38 173.587 295.893C174.072 295.407 174.344 294.748 174.344 294.061Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.356386,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M302.289 313.95C302.289 313.95 305.565 320.602 307.904 324.361C310.244 328.119 314.587 333.063 314.143 337.415C313.698 341.766 309.167 342.234 304.504 339.754C299.841 337.274 295.645 332.299 294.367 328.564C293.088 324.828 289.079 321.725 289.079 317.529C289.079 313.334 289.391 312.85 290.943 312.398C292.495 311.946 300.738 311.306 302.289 313.95Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M289.079 317.521C289.079 316.905 289.079 316.375 289.079 315.907C289.51 317.205 290.032 318.472 290.639 319.697C292.354 323.12 294.842 325.156 295.77 329.336C296.698 333.515 302.609 338.35 307.74 339.59C312.871 340.83 313.979 336.642 313.979 336.642H314.166C314.185 336.902 314.185 337.163 314.166 337.422C313.698 341.774 309.191 342.242 304.527 339.762C299.864 337.282 295.669 332.307 294.39 328.571C293.111 324.836 289.079 321.717 289.079 317.521Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M301.666 316.742C301.666 316.742 299.794 319.386 293.579 318.614",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M301.821 318.925C299.974 320.378 297.63 321.047 295.294 320.789",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M302.445 320.789C301.759 321.532 300.907 322.102 299.958 322.453C299.009 322.804 297.991 322.926 296.987 322.809",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M303.069 323.433C303.069 323.433 301.977 325.608 297.782 325.14",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M262.503 319.822C260.164 323.503 256.949 326.547 253.146 328.681C247.086 331.948 239.312 334.14 238.696 335.699C238.435 336.265 238.386 336.905 238.556 337.504C238.726 338.103 239.105 338.622 239.624 338.967C240.403 339.427 251.906 339.746 257.965 338.655C261.384 337.924 264.88 337.61 268.375 337.719C271.175 337.719 277.234 338.499 278.014 335.075C278.794 331.652 276.774 319.222 276.774 319.222C276.774 319.222 267.634 321.873 262.503 319.822Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M239.654 338.974C239.253 338.708 238.934 338.335 238.736 337.896C238.537 337.457 238.466 336.971 238.531 336.494C240.944 337.082 243.397 337.494 245.87 337.726C252.108 338.35 261.411 336.331 268.718 336.019C274.083 335.792 277.015 334.553 278.193 333.921C278.172 334.311 278.122 334.7 278.045 335.083C277.265 338.506 271.206 337.726 268.406 337.726C264.911 337.617 261.415 337.931 257.996 338.662C251.937 339.746 240.434 339.434 239.654 338.974Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M260.171 323.433C261.369 324.389 262.328 325.612 262.971 327.004",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M258.307 325.756C258.307 325.756 260.327 327.471 260.327 328.555",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 327.315C256.811 328.196 257.227 329.136 257.528 330.115",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M253.177 328.712C253.177 328.712 254.424 329.804 254.424 330.888",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M306.399 154.759C306.399 154.759 311.343 178.286 310.953 191.153C310.563 204.02 293.017 235.992 293.017 235.992C293.017 235.992 302.375 258.997 302.765 269.134C303.155 279.272 302.36 311.907 302.36 311.907C302.36 311.907 298.461 314.169 294.928 314.169C291.395 314.169 287.177 312.391 287.177 312.391L278.201 277.299L277.811 319.799C275.215 321.337 272.251 322.145 269.233 322.138C266.163 322.12 263.171 321.168 260.655 319.409C260.655 319.409 254.417 274.57 253.637 267.161C252.857 259.753 247.788 237.528 247.398 235.969C247.008 234.409 239.6 209.845 239.6 189.96C239.6 170.074 245.316 158.12 245.316 158.12C245.316 158.12 265.334 153.698 280.15 153.308C288.925 153.067 297.705 153.552 306.399 154.759Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M275.471 271.473C275.471 271.473 265.334 242.62 265.334 235.602C265.334 228.584 271.962 184.914 271.962 184.914",
    stroke: "#878787",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M269.233 198.171C269.233 198.171 263.384 191.543 261.435 187.644",
    stroke: "#878787",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M246.096 94.978C246.096 94.978 238.04 99.6569 233.619 106.675C229.197 113.694 219.582 143.327 220.104 150.86C220.627 158.393 222.958 160.482 229.719 159.18C236.48 157.878 236.995 150.345 238.555 144.106C240.114 137.868 248.435 98.3546 248.435 98.3546L248.692 94.7129L246.096 94.978Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M220.105 150.859C219.839 147.023 222.202 137.447 225.173 128.05L241.62 130.327C240.239 136.721 239.054 142.094 238.555 144.083C236.995 150.321 236.481 157.854 229.72 159.157C222.959 160.459 220.619 158.4 220.105 150.859Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M299.903 92.6386C299.903 92.6386 306.141 93.9331 307.701 104.851C309.261 115.768 305.619 133.704 305.619 133.704L306.399 154.759C306.399 154.759 280.407 161.52 269.747 161.52C259.087 161.52 245.316 158.143 245.316 158.143C245.316 158.143 251.032 105.63 252.077 101.217C253.122 96.8028 257.793 92.3735 261.692 89.5194C265.591 86.6652 275.471 86.9148 281.187 88.4744C286.903 90.034 294.967 93.1533 294.967 93.1533L299.903 92.6386Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M281.187 85.3555C281.187 85.3555 275.729 107.455 275.206 122.529C274.684 137.603 277.546 184.392 277.546 184.392C277.546 184.392 289.765 184.914 298.601 183.355C307.436 181.795 313.682 181.015 313.682 181.015L305.884 132.409C305.884 132.409 295.224 133.189 292.884 125.648C290.545 118.108 293.664 103.034 296.526 98.355C299.388 93.6761 299.903 92.6389 299.903 92.6389L281.187 85.3555Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M257.536 105.896C257.536 105.896 251.812 127.73 252.334 149.565C252.857 171.4 253.114 183.097 253.114 183.097C253.114 183.097 240.637 182.317 233.619 179.456C233.619 179.456 237.518 128.51 241.159 113.429C244.801 98.347 246.096 94.9782 246.096 94.9782L260.655 88.9971L257.536 105.896Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M275.588 81.1132C275.588 81.1132 281.047 82.1269 282.482 84.9654C283.917 87.804 276.805 111.12 276.805 111.12L266.464 102.605L253.691 109.904C253.691 109.904 256.124 92.2645 261.395 86.182C266.667 80.0994 275.588 81.1132 275.588 81.1132Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M277.818 66.3193C277.818 66.3193 278.021 86.7895 275.791 92.0532C273.561 97.317 267.681 105.029 265.451 103.813C263.22 102.596 262.612 87.7954 262.207 86.7817C261.801 85.7679 260.179 77.4239 260.179 77.4239C260.179 77.4239 274.777 73.4001 277.818 66.3193Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M277.818 66.3193C277.818 66.3193 277.896 74.5386 277.39 81.9156C275.063 84.6709 271.794 86.4612 268.219 86.9376C266.229 87.2389 264.203 87.2125 262.222 86.8596C262.226 86.8416 262.226 86.8231 262.222 86.8051C261.817 85.7913 260.195 77.4473 260.195 77.4473C260.195 77.4473 274.777 73.4001 277.818 66.3193Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M255.009 136.752L256.569 137.704L265.591 122.958C265.715 122.751 265.753 122.505 265.696 122.271C265.639 122.037 265.492 121.836 265.287 121.71C265.186 121.647 265.073 121.605 264.955 121.586C264.838 121.567 264.717 121.571 264.602 121.599C264.486 121.626 264.376 121.676 264.28 121.746C264.183 121.816 264.102 121.905 264.039 122.006L255.009 136.752Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M299.903 92.6387C299.903 92.6387 305.884 93.1534 309.518 100.172C313.152 107.19 318.876 140.207 319.921 149.822C320.966 159.438 315.242 158.658 314.462 158.658C313.682 158.658 272.352 144.886 272.352 144.886L258.315 143.327C258.315 143.327 259.875 144.621 258.573 144.621C257.271 144.621 254.674 142.024 253.637 140.465C252.599 138.905 256.756 130.327 258.315 129.29C259.875 128.253 273.912 138.648 273.912 138.648L301.205 140.465L294.187 116.548",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M299.903 92.6387C299.903 92.6387 305.884 93.1534 309.518 100.172C313.152 107.19 318.876 140.207 319.921 149.822C320.966 159.438 315.242 158.658 314.462 158.658C313.682 158.658 272.352 144.886 272.352 144.886L258.315 143.327C258.315 143.327 259.875 144.621 258.573 144.621C257.271 144.621 254.674 142.024 253.637 140.465C252.599 138.905 256.756 130.327 258.315 129.29C259.875 128.253 273.912 138.648 273.912 138.648L301.205 140.465L294.187 116.548",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M258.316 129.29C259.875 128.245 273.912 138.647 273.912 138.647L301.205 140.464L299.474 134.569L316.934 130.631C318.377 138.64 319.508 146.04 319.921 149.822C320.958 159.437 315.242 158.657 314.462 158.657C313.682 158.657 272.352 144.886 272.352 144.886L258.316 143.326C258.316 143.326 259.875 144.621 258.573 144.621C257.271 144.621 254.674 142.024 253.637 140.464C252.6 138.905 256.756 130.327 258.316 129.29Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M258.316 129.29C259.875 128.245 273.912 138.647 273.912 138.647L277.889 138.912C277.904 141.43 277.285 143.911 276.088 146.126L272.352 144.886L258.316 143.326C258.316 143.326 259.875 144.621 258.573 144.621C257.271 144.621 254.674 142.024 253.637 140.464C252.599 138.905 256.756 130.327 258.316 129.29Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M244.536 117.07L271.05 154.244L236.215 152.942L211.004 118.63L244.536 117.07Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M232.831 115.979L234.866 119.363L219.621 119.706L217.586 116.314L232.831 115.979Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M222.53 138.164C223.727 138.601 224.974 138.889 226.242 139.021C227.801 139.092 229.236 139.879 229.236 140.667C229.236 141.454 226.452 141.595 224.456 141.595C222.46 141.595 220.892 141.166 220.557 139.879C220.222 138.593 220.674 137.454 222.53 138.164Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M220.736 134.679C222.246 135.232 223.817 135.599 225.415 135.771C227.404 135.856 229.213 136.855 229.213 137.845C229.213 138.835 225.688 139.022 223.154 139.022C220.619 139.022 218.631 138.484 218.179 136.855C217.726 135.225 218.381 133.774 220.736 134.679Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M219.293 131.699C220.803 132.253 222.374 132.619 223.972 132.791C225.969 132.877 227.778 133.875 227.778 134.865C227.778 135.856 224.245 136.043 221.711 136.043C219.176 136.043 217.188 135.505 216.736 133.875C216.283 132.245 216.938 130.795 219.293 131.699Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M218.319 128.33C219.829 128.879 221.4 129.243 222.998 129.414C224.986 129.5 226.795 130.498 226.795 131.496C226.795 132.494 223.271 132.674 220.736 132.674C218.202 132.674 216.213 132.128 215.761 130.498C215.309 128.868 215.964 127.426 218.319 128.33Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M303.163 304.476C303.163 304.476 303.326 312.554 303.007 313.833C302.687 315.112 297.026 316.734 293.477 316.734C289.929 316.734 287.66 315.954 287.013 314.964C286.365 313.974 285.243 307.369 285.243 307.369C285.243 307.369 297.837 309.973 303.163 304.476Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M285.289 59.8314C287.817 58.941 290.536 58.7346 293.169 59.2331C295.803 59.7316 298.258 60.9172 300.285 62.6699C307.382 68.7525 301.065 79.7011 293.594 80.9176C286.124 82.1341 281.234 78.6873 280.018 73.213C278.801 67.7387 280.813 59.6286 285.289 59.8314Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 58.0073C249.418 58.0073 250.432 68.1449 252.459 75.2412C254.487 82.3375 259.758 84.9732 267.276 83.9595C274.793 82.9457 279.035 76.8632 281.468 69.7669C283.901 62.6706 284.104 52.9385 284.104 52.9385L249.418 58.0073Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M283.043 57.8039C283.043 57.8039 280.61 60.0342 275.151 56.1819C269.693 52.3296 272.313 50.5049 272.313 50.5049L285.289 51.2847L283.043 57.8039Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M257.496 60.4395C257.496 60.4395 258.51 63.4807 257.902 64.4945C257.294 65.5083 255.672 66.9275 257.496 68.5495C257.827 68.8723 258.229 69.1126 258.67 69.251C259.111 69.3894 259.578 69.4219 260.034 69.3459C260.489 69.27 260.921 69.0877 261.293 68.8138C261.665 68.54 261.967 68.1823 262.175 67.7697",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M268.804 69.501C268.804 69.501 265.684 73.5482 259.773 71.6845",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M264.39 61.6564C264.39 62.7794 264.843 63.6839 265.404 63.6839C265.966 63.6839 266.418 62.7794 266.418 61.6564C266.418 60.5335 265.966 59.6289 265.404 59.6289C264.843 59.6289 264.39 60.5335 264.39 61.6564Z",
    fill: "#263238"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M253.239 63.2629C253.239 64.3858 253.691 65.2904 254.253 65.2904C254.814 65.2904 255.267 64.3858 255.267 63.2629C255.267 62.1399 254.814 61.2354 254.253 61.2354C253.691 61.2354 253.239 62.1555 253.239 63.2629Z",
    fill: "#263238"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M268.648 57.1957C268.648 57.1957 265.809 53.9517 262.16 57.1957",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M255.656 58.8174C255.031 58.3566 254.267 58.1251 253.491 58.162C252.716 58.199 251.977 58.502 251.398 59.0202",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M286.069 53.7493L248.357 57.8043C248.357 57.8043 248.762 38.7456 248.965 35.5094C249.168 32.2732 264.172 27.8048 270.02 28.2103C275.869 28.6158 283.199 32.0626 284.416 33.669C285.632 35.2754 286.069 53.7493 286.069 53.7493Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M269.864 55.7765L236.418 60.237C236.418 60.237 245.331 52.5324 252.428 51.9242C259.524 51.3159 269.864 55.7765 269.864 55.7765Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M281.624 59.2238C281.624 59.2238 282.404 52.9385 285.882 52.9385C289.36 52.9385 287.707 58.0073 287.301 61.2513C286.896 64.4953 283.044 65.3063 281.624 64.0898",
    fill: "#CFCFCF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M281.624 59.2238C281.624 59.2238 282.404 52.9385 285.882 52.9385C289.36 52.9385 287.707 58.0073 287.301 61.2513C286.896 64.4953 283.044 65.3063 281.624 64.0898",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M278.13 312.874L277.647 320.469C277.647 320.469 275.502 322.076 269.233 322.162C262.963 322.247 260.655 319.432 260.655 319.432L259.399 311.244C259.399 311.244 271.026 316.75 278.13 312.874Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services_.f684c3243986266b158b4fb3935a2660.svg";
export { ForwardRef as ReactComponent };